import React from 'react';
import PropTypes from 'prop-types';
import {Grid, Paper, withStyles} from '@material-ui/core';

const NoResultPlaceholder = ({backgroundColor, imageUrl, title, description}) => {
    const Image = withStyles(() => ({
        root: {
            background: `url("${imageUrl}")  no-repeat center / 100% 100%`,
            backgroundColor,
        },
    }))(Paper);

    return (
        <Grid
            container
            className="no-result-placeholder-container"
            direction="column"
            justifyContent="space-evenly"
            alignItems="center"
        >
            {title && (
                <Grid item>
                    <div className="no-result-placeholder-title">{title}</div>
                </Grid>
            )}
            {description && (
                <Grid item>
                    <div className="no-result-placeholder-description">{description}</div>
                </Grid>
            )}
            <Grid item>
                <Image elevation={0} className="no-result-placeholder-image" />
            </Grid>
        </Grid>
    );
};

NoResultPlaceholder.defaultProps = {
    backgroundColor: undefined,
};

NoResultPlaceholder.propTypes = {
    backgroundColor: PropTypes.string,
    imageUrl: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
};

export default NoResultPlaceholder;
